import { createSelector } from "reselect";
import {
  createGetResourceRecordsSelector,
  createGetAllResourcesRequestSelector,
  createGetPatchOneMessageTemplatesRequestSelector,
  createGetAllMessageTemplatesSelector
} from "./resources";

const getMessageTemplatesRecords = createGetResourceRecordsSelector("messageTemplate");

export const getAllMessageTemplatesRequest = createGetAllResourcesRequestSelector("messageTemplate");
export const getPatchOneMessageTemplatesRequest = createGetPatchOneMessageTemplatesRequestSelector("messageTemplate");
export const getAllMessageTemplates = createGetAllMessageTemplatesSelector(
  "messageTemplate",
  getMessageTemplatesRecords,
  getAllMessageTemplatesRequest
);

export const getSurveyMessageTemplate = createSelector(
  getAllMessageTemplates,
  messageTemplates => (
    messageTemplates ? messageTemplates.find(mt => mt.templateType === "survey") : null
  )
);
